import { Component, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'atn-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss'],
  animations: [
    trigger('errorAnimation', [
      transition(':enter', [
        style({transform: 'translateY(-100%)'}),
        animate('400ms', style({transform: 'translateY(0)'}))
      ]),
      transition(':leave', [
        style({transform: 'translateY(0)'}),
        animate('400ms', style({transform: 'translateY(-100%)'}))
      ])
    ])
  ]
})
export class InputErrorComponent {
  @Input() msg: string;
  @Input() show: boolean;

  constructor() {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/input-error/input-error.component.ts